import { getAccessToken } from '@auth/services/getAccessToken';
import { type AppDispatch } from '@store/configureStore';
import { type RootState } from '@store/rootReducer';
import { logout } from '@store/session/logout';
import { impersonate, updateToken } from '@store/session/reducer';

import { refreshImpersonateToken } from './refreshImpersonateToken';

let isRefreshing: null | Promise<boolean> = null;

const refreshTokenSession = async (
  session: RootState['session'],
  user: RootState['user'],
  dispatch: AppDispatch,
): Promise<boolean> => {
  const { accessToken, idToken } = await getAccessToken().catch(error => {
    if (!import.meta.env.PROD) {
      console.error(error);
    }

    return { accessToken: '', idToken: '' };
  });

  const impersonatedUser = user.impersonatedUser?.user;

  if (impersonatedUser !== undefined) {
    const { accessToken, idToken } = session.credentials;
    const impersonationToken = await refreshImpersonateToken({
      accessToken,
      idToken,
      userId: impersonatedUser.username,
    }).catch(() => '');
    dispatch(impersonate({ impersonationToken }));
  }

  if (accessToken !== '') {
    dispatch(updateToken({ accessToken, idToken }));

    return true;
  }

  await dispatch(logout());

  return false;
};

const initRefreshToken = (
  session: RootState['session'],
  user: RootState['user'],
  dispatch: AppDispatch,
) => {
  if (isRefreshing == null) {
    isRefreshing = refreshTokenSession(session, user, dispatch).finally(
      () => (isRefreshing = null),
    );
  }

  return { isRefreshing };
};

export { initRefreshToken, isRefreshing };
